import {
  useState,
  useEffect,
  forwardRef,
  useRef,
  useImperativeHandle,
} from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import {
  IconButton,
  InputAdornment,
  TextField,
  Button,
  InputLabel,
} from '@mui/material'

import useStyles from '../../../App/Home/styles'
import useTranslations from '../../../i18n/useTranslations'
import { ReactComponent as MagnifyingGlass } from '../../../assets/icons/magnifying-glass.svg'
import { ReactComponent as X } from '../../../assets/icons/x.svg'

const SearchField = forwardRef((props, ref) => {
  const {
    id,
    initialValue = '',
    className,
    label,
    helperText,
    placeholder,
    onSearch,
    onChangeValue = () => {},
    onClear = () => {},
    showClearIcon,
    showSearchIcon,
    showButton,
    isDisabled,
    fullWidth,
    testId = 'shipment-tracking-input',
    isButtonDisabledValidation = value => !Boolean(value),
  } = props

  const buttonRef = useRef()
  useImperativeHandle(ref, () => ({
    onClick: handleSearch,
  }))

  const t = useTranslations()
  const classes = useStyles()
  const showEndAdornment = showClearIcon || showSearchIcon

  const [value, setValue] = useState(initialValue)
  useEffect(() => {
    if (initialValue == null) return

    // NOTE: limpia el campo cuando se limpie el filtro desde fuera
    setValue(initialValue)
  }, [initialValue])
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [isActive, setIsActive] = useState(false)

  const handleSearch = () => {
    if (Boolean(value)) {
      onSearch(value)
      setIsActive(true)
    } else {
      handleClear()
    }
  }

  const handleChangeInput = ev => {
    const newValue = ev.target.value
    setValue(newValue)
    onChangeValue(newValue)
    setIsButtonDisabled(isButtonDisabledValidation(newValue))
  }

  const onKeyPressInput = ev => {
    if (ev.key === 'Enter') {
      ev.preventDefault()
      handleSearch()
    }
  }

  const handleClear = () => {
    setValue('')
    onClear()
    setIsActive(false)
    // document.getElementById('endIcon').blur()
  }

  const handleMouseDown = event => {
    event.preventDefault()
  }

  return (
    <>
      {label ? <InputLabel>{label}</InputLabel> : null}
      <TextField
        type="text"
        name={id}
        id={id}
        fullWidth={fullWidth}
        className={clsx(className, isActive && 'active')}
        onChange={handleChangeInput}
        onKeyPress={onKeyPressInput}
        value={value}
        helperText={helperText}
        placeholder={placeholder}
        disabled={isDisabled}
        InputProps={{
          testId: testId,
          endAdornment: showEndAdornment ? (
            <InputAdornment position="end">
              {showClearIcon && value !== '' && (
                <IconButton
                  className={clsx(classes.iconButton, classes.clearButton)}
                  onClick={handleClear}
                  onMouseDown={handleMouseDown}
                >
                  <X />
                </IconButton>
              )}
              {showSearchIcon && (
                <IconButton
                  onClick={handleSearch}
                  aria-label="search"
                  size="large"
                  disabled={isButtonDisabled}
                  type="submit"
                >
                  <MagnifyingGlass />
                </IconButton>
              )}
            </InputAdornment>
          ) : null,
        }}
      />
      {showButton && (
        <Button
          ref={buttonRef}
          className={classes.shippingButton}
          size="small"
          disabled={isButtonDisabled}
          onClick={handleSearch}
        >
          {t('action:search')}
        </Button>
      )}
    </>
  )
})

SearchField.propTypes = {
  id: PropTypes.string,
  initialValue: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  placeholder: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  onChangeValue: PropTypes.func,
  onClear: PropTypes.func,
  showClearIcon: PropTypes.bool,
  showSearchIcon: PropTypes.bool,
  showButton: PropTypes.bool,
  isDisabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  isButtonDisabledValidation: PropTypes.func,
  testId: PropTypes.string,
}

export default SearchField
